/**
 * Configuration class for dotcms-js. You can extend this class to overide one to many config options and inject
 * the your AppConfig in the app.module ts file of your application
 */
var AppConfig = (function () {
    function AppConfig() {
        this.iconPath = './src/assets/images/icons';
        this.dotCMSURLKey = 'siteURLJWT';
    }
    return AppConfig;
}());
export { AppConfig };
//# sourceMappingURL=app.config.js.map